<template>
  <TMenuItem
    v-for="item in MenuPublicInstance"
    :key="item.name"
    :href="item.href"
    :icon="item.icon"
    :selected="item.selected"
    :aria-label="t(item.name)"
  >
    {{ t(item.name) }}
  </TMenuItem>
</template>

<script setup lang="ts">
import { useMenuPublic } from '../composables/useMenuPublic'

const { MenuPublicInstance } = await useMenuPublic()
</script>
